import { createAction } from '@reduxjs/toolkit'
import { arrayDataChart, arrayDataToken } from './types'

export const fetchDataChart = createAction<arrayDataChart>('infoV2/fetchDataChart')
export const fetchData = createAction<arrayDataToken>('infoV2/fetchData')
